export const redirectUri = import.meta.env.VITE_REDIRECT_URL!;
